"use client";

import React from "react";
import Link from "next/link";
import { CheckSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

interface PopoverItemsSummaryProps {
  items: Array<{ id: string; title: string }>;
  label: string;
  viewAllHref: string;
  icon?: React.ReactNode;
  maxVisible?: number;
}

export function PopoverItemsSummary({
  items,
  label,
  viewAllHref,
  icon = <CheckSquare className="h-3 w-3" />,
  maxVisible = 3,
}: PopoverItemsSummaryProps) {
  if (items.length === 0) return null;

  return (
    <div className="bg-card-50 p-3 rounded-lg">
      <div className="flex items-center justify-between mb-2">
        <h5 className="text-sm font-medium text-card-foreground flex items-center gap-1">
          {icon}
          {label} ({items.length})
        </h5>
        <Button asChild variant="ghost" size="sm" className="text-xs h-6 px-2">
          <Link href={viewAllHref}>View All</Link>
        </Button>
      </div>
      <div className="flex flex-wrap gap-1">
        {items.slice(0, maxVisible).map((item) => (
          <Badge
            key={item.id}
            variant="outline"
            className="text-xs max-w-24 truncate"
            title={item.title}
          >
            {item.title}
          </Badge>
        ))}
        {items.length > maxVisible && (
          <Badge variant="outline" className="text-xs">
            +{items.length - maxVisible} more
          </Badge>
        )}
      </div>
    </div>
  );
}
